import SET_SECONDARY_INSURANCE from "../mutations/insurance/set-secondary-insurance";

function editSecondaryInsuranceInfo(memberId, secondaryInsuranceOptions, client) {
  return client.mutate({
    mutation: SET_SECONDARY_INSURANCE,
    fetchPolicy: 'no-cache',
    variables: {
      memberId: memberId,
      secondaryInsurance: secondaryInsuranceOptions
    }
  });
}

export default editSecondaryInsuranceInfo;
